 attribute float alpha;
      varying float vAlpha;
      varying vec3 vColor;
      void main(){
        vColor = color;
        vAlpha = alpha* 0.8;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.5);
      }
    



